import { schema } from 'normalizr';

import { processCurrentNetwork } from '../strategies/currentNetwork';

export const currentNetworkSchema: schema.Entity = new schema.Entity(
  'networks',
  {},
  { processStrategy: processCurrentNetwork }
);
